import React from 'react'
import * as styles from './trustedByGrid.module.scss'
import SectionWithGrid from 'common/SectionWithGrid'

import Media from 'common/Media'

export default function TrustedByGrid({ title, grid }) {
  return (
    <SectionWithGrid
      className={styles.section}
      grid={grid}
      title={title}
      titleAs="h3"
      gridItem={(props) => (
        <li key={props.id}>
          <Media {...props} />
        </li>
      )}
    />
  )
}
